import createAction from 'redux-actions/es/createAction';

export const validateMfaRequest = createAction('VALIDATE_MFA_REQUEST');
export const validateMfaSuccess = createAction('VALIDATE_MFA_SUCCESS');
export const validateMfaFail = createAction('VALIDATE_MFA_FAIL');
